import { CollectionEntity } from "@busy-human/gearbox";
export var Aircraft;
(function (Aircraft) {
    let VehicleType;
    (function (VehicleType) {
        VehicleType["Rotor"] = "rotor";
        VehicleType["FixedWing"] = "fixed-wing";
        VehicleType["Ground"] = "ground";
    })(VehicleType = Aircraft.VehicleType || (Aircraft.VehicleType = {}));
    Aircraft.VehicleTypeReadableMap = {
        [VehicleType.Rotor]: "Rotor",
        [VehicleType.FixedWing]: "Fixed Wing",
        [VehicleType.Ground]: "Ground"
    };
    function Defaults() {
        return {
            esn: null,
            model: null,
            lastUpdated: null,
            isActive: false,
            vehicleType: null,
            vehicleId: null,
            location: null
        };
    }
    Aircraft.Defaults = Defaults;
    class CollectionClass extends CollectionEntity {
        relationships = {};
        defaults() {
            return Defaults();
        }
    }
    Aircraft.CollectionClass = CollectionClass;
})(Aircraft || (Aircraft = {}));
//# sourceMappingURL=index.js.map